import { SelectedDifficulty } from "@/models/shared";
import Difficulty1 from "@/assets/difficulty-1.png";
import Difficulty2 from "@/assets/difficulty-2.png";
import Difficulty3 from "@/assets/difficulty-3.png";

export interface Difficulty {
  level: SelectedDifficulty;
  title: string;
  body: string;
  image: string;
}

export const difficulties: Difficulty[] = [
  {
    level: "easy",
    title: "EINSTEIGER",
    body: "Dein erstes Krimi-Spiel von uns? Keine Panik, der Kommissar hilft dir an den schwierigen Stellen weiter!",
    image: Difficulty1,
  },
  {
    level: "medium",
    title: "MITTEL",
    body: "Du hast bereits zwei bis fünf ähnliche Spiele gelöst? Super, du bekommst Tipps aber ein paar schwierige Rätsel musst du selbst lösen!",
    image: Difficulty2,
  },
  {
    level: "hard",
    title: "PROFI",
    body: "Du hast gefühlt schon fast alles gespielt was es so gibt? Perfekt, wir haben hier ein paar wirklich harte Nüsse für dich!",
    image: Difficulty3,
  },
];
